import React from 'react';
import {
  Grid, 
  Tab
} from '@material-ui/core';
import {
  setSelectedAdminTab
} from 'store/actions';
import { withStyles } from '@material-ui/core/styles';
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import AppMessagesTab from './AppMessagesTab';
import ReleasesTab from './ReleasesTab';
import IntegrationsTab from './IntegrationsTab';
import ProcessingItemsTab from './ProcessingItemsTab';
import PostAcqImport from './PostAcqImportTab';


const Administration = ({ classes, 
  onClose,
  selectedTab,
  setSelectedTab,
   ...props }) => {

  function handleTabChange(event, value) {
    setSelectedTab(value);
  }

    return (
      <div className={classes.root}>
        <TabContext value={selectedTab} >
          <Grid item>
            <TabList onChange={handleTabChange} className={classes.tabsRoot}>
              <Tab label="App Messages" value="appMessages" className={classes.roundedTab} />
              <Tab label="Releases" value="releases" className={classes.roundedTab} />
              <Tab label="Constants" value="constants" className={classes.roundedTab} />
              <Tab label="Integrations" value="integrations" className={classes.roundedTab} />
              <Tab label="Processing" value="processesing" className={classes.roundedTab} />
              <Tab label="Post-Acq Import" value="postAcqImport" className={classes.roundedTab} />
            </TabList>
          </Grid>
          <Grid item style={{ flexGrow: 1, paddingBottom: 30 }}>
            <TabPanel value='appMessages' index={0} className={classes.tabPanel}>
              <AppMessagesTab />
            </TabPanel>
            <TabPanel value='releases' index={0} className={classes.tabPanel}>
              <ReleasesTab />
            </TabPanel>
            <TabPanel value='constants' index={0} className={classes.tabPanel}>
              Here goes Constants tab content.
            </TabPanel>
            <TabPanel value='integrations' index={0} className={classes.tabPanel}>
              <IntegrationsTab />
            </TabPanel>
            <TabPanel value='processesing' index={0} className={classes.tabPanel}>
              <ProcessingItemsTab />
            </TabPanel>
            <TabPanel value='postAcqImport' index={0} className={classes.tabPanel}>
              <PostAcqImport />
            </TabPanel>
          </Grid>
        </TabContext>
      </div>
    );
  };

  const styles = theme => ({
    root:{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '30px 30px 0 30px'
    },
    tabsRoot: {
      minHeight: 0
    },
    roundedTab: {
      backgroundColor: '#e6e6e6',
      borderRadius: '8px 8px 0 0',
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
      minHeight: 0,
      minWidth: 0,
      padding: '8px 16px'
    },
    tabPanel: {
      padding: 2,
      height: '100%'
    },
  });

  const mapStateToProps = (state) => ({
    selectedTab: state.adminState.selectedAdminTab,
  });

  const mapDispatchToProps = (dispatch) => ({
    setSelectedTab: (tab) => dispatch(setSelectedAdminTab(tab)),
  });

  export default compose(
    withRouter,
    withStyles(styles),
    connect(
      mapStateToProps,
      mapDispatchToProps
    )
  )(Administration);
